import React from 'react';

export const FormErrors = ({formErrors}) => {
    return (
        <div className='justify-content-start'>
            { formErrors !== '' && <div className="error-message-cms">{formErrors}</div> }
        </div>
    )
}
    